export function formatRoundName(companyName: string, round?: string | null): string {
  if (!round) {
    return '';
  }
  const excess = ` - ${companyName}`;
  if (round.indexOf(excess) === -1) {
    return round;
  }
  return round.split(excess)[0];
}
